import {CASE_REJECT_ATTORNEY_MODAL, CASE_RESUBMIT_MODAL} from "../redux/reducers/modal";

export const showApproveCaseModal = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: 'CASE_APPROVE_MODAL', payload: data})
    }
};

export const showRejectCaseModal = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: 'CASE_REJECT_MODAL', payload: data})
    }
};

export const showRejectAttorneyModal = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: CASE_REJECT_ATTORNEY_MODAL, payload: data})
    }
};

export const showResubmitCaseModal = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: CASE_RESUBMIT_MODAL, payload: data})
    }
};

